export const SEGMENTED_TRACK_CLASS = 'rounded-xl bg-button-primary bg-clip-border p-1';

export const SEGMENT_BASE_CLASS =
  'rounded-lg font-medium outline-none transition-[color,background-color,box-shadow] focus-visible:ring-2 focus-visible:ring-white/70 motion-reduce:transition-none';

export const SEGMENT_ACTIVE_CLASS =
  'bg-card text-brand-link shadow-[0_4px_12px_-6px_color-mix(in_oklab,var(--color-brand-link)_80%,transparent)]';

export const SEGMENT_INACTIVE_CLASS = 'text-white/80 hover:bg-white/10 hover:text-white';

export const COUNT_CHIP_CLASS =
  'min-w-6 rounded-full px-1.5 py-0.5 text-center text-xs font-medium tabular-nums';

export const COUNT_CHIP_ON_DARK_CLASS = 'bg-white/15 text-white/90';
